import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {AnalysisPriorityModesActions} from '../store';
import {AnalysisPriorityModesSelectors} from '../store/selectors';
import {ApplicationState} from '../../application-state/store';

@Injectable()
export class AnalysisPriorityModesLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadAnalysisPriorityModesDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadAnalysisPriorityModesDone() {

    return this.store.pipe(
      select(AnalysisPriorityModesSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(AnalysisPriorityModesActions.ReadAnalysisPriorityModes());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
